/* eslint-disable prefer-rest-params */
import i18next from 'i18next';
import { isUndefined } from 'lodash';
import axios from 'src/utils/axios';
import logger from 'src/utils/logger';
import parse from 'src/utils/parse';

type ReportingPayloadType = {
  billingAccountId?: string;
  page: number;
  pageSize: number;
  organizationId: string;
  to: string;
  from: string;
  sprintId: string;
  column?: string;
  sort?: number;
};

class ReportingApi {
  async getAllReportings({
    billingAccountId,
    page,
    pageSize,
    organizationId,
    to,
    from,
    sprintId,
    column,
    sort,
  }: ReportingPayloadType): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${process.env.REACT_APP_CASES}/cases/billableStatistics?billingAccountId=${billingAccountId}&page=${page}&pageSize=${pageSize}&to=${to}&from=${from}&organizationId
=${organizationId}&sprintId=${sprintId}`,
          {
            params: {
              column,
              sort,
            },
          }
        )
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async getOrganizations(): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(`${process.env.REACT_APP_CASES}/auto-complete/organizations`)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response)) {
            resolve(response);
          } else {
            reject(new Error(i18next.t('invalid_server_response')));
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(new Error(i18next.t('internal_server_error')));
        });
    });
  }

  async getBillingAccounts({ orgId }: { orgId: string }): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${process.env.REACT_APP_CASES}/auto-complete/billingAccount/${orgId}`
        )
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response)) {
            resolve(response);
          } else {
            reject(new Error(i18next.t('invalid_server_response')));
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(new Error(i18next.t('internal_server_error')));
        });
    });
  }

  async getMixChartData({
    organizationId,
  }: {
    organizationId: string;
  }): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${process.env.REACT_APP_CASES}/cases/loggedTime/organization-wise/chart`,
          {
            params: {
              organizationId,
            },
          }
        )
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response)) {
            resolve(response);
          } else {
            reject(new Error(i18next.t('invalid_server_response')));
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(new Error(i18next.t('internal_server_error')));
        });
    });
  }

  async getAllBillingAccounts(): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(`${process.env.REACT_APP_CASES}/auto-complete/billingAccount/all`)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response)) {
            resolve(response);
          } else {
            reject(new Error(i18next.t('invalid_server_response')));
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(new Error(i18next.t('internal_server_error')));
        });
    });
  }

  async getWeeklyLoggedHoursByAccount(): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(`${process.env.REACT_APP_CASES}/cases/weeklyloggedhoursbyaccount`)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response)) {
            resolve(response);
          } else {
            reject(new Error(i18next.t('invalid_server_response')));
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(new Error(i18next.t('internal_server_error')));
        });
    });
  }

  async getBillingAccountsByProjectId({
    projectId,
  }: {
    projectId: string;
  }): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${process.env.REACT_APP_CASES}/auto-complete/project/billingAccount/${projectId}`
        )
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response)) {
            resolve(response);
          } else {
            reject(new Error(i18next.t('invalid_server_response')));
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(new Error(i18next.t('internal_server_error')));
        });
    });
  }

  async getOrganizationsSprints({
    orgId,
  }: {
    search?: string;
    orgId: string;
  }): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${process.env.REACT_APP_CASES}/sprint/getSprintByOrganization/${orgId}`
        )
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response)) {
            resolve(response);
          } else {
            reject(new Error(i18next.t('invalid_server_response')));
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(new Error(i18next.t('internal_server_error')));
        });
    });
  }

  async getSummaryData({
    sprintId,
    billingAccountId,
    organizationId,
    from,
    to,
  }: {
    sprintId: string;
    billingAccountId: string;
    organizationId: string;
    from: string;
    to: string;
  }): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(`${process.env.REACT_APP_CASES}/cases/account/loggedTimeV2`, {
          params: {
            billingAccountId,
            organizationId,
            sprintId,
            from,
            to,
            page: 0,
            pageSize: 1000000000,
          },
        })
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response)) {
            resolve(response);
          } else {
            reject(new Error(i18next.t('invalid_server_response')));
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(new Error(i18next.t('internal_server_error')));
        });
    });
  }

  async getSprintWiseChartData({
    orgId,
    billingAccountId,
  }: {
    orgId: string;
    billingAccountId: string;
  }): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${process.env.REACT_APP_CASES}/cases/sprint/loggedTime/${orgId}`,
          {
            params: {
              limit: 10,
              billingAccountId:
                billingAccountId === 'all' ? null : billingAccountId,
            },
          }
        )
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response)) {
            resolve(response);
          } else {
            reject(new Error(i18next.t('invalid_server_response')));
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(new Error(i18next.t('internal_server_error')));
        });
    });
  }

  async getAccountWiseHourComparisonData({
    orgId,
    billingAccountId,
  }: {
    orgId: string;
    billingAccountId: string;
  }): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${process.env.REACT_APP_CASES}/cases/sprint/account/loggedTime/${orgId}`,
          {
            params: {
              limit: 10,
              billingAccountId:
                billingAccountId === 'all' ? null : billingAccountId,
            },
          }
        )
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response)) {
            resolve(response);
          } else {
            reject(new Error(i18next.t('invalid_server_response')));
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(new Error(i18next.t('internal_server_error')));
        });
    });
  }

  async getPieChartData({
    sprintIndex,
  }: {
    sprintIndex: string;
  }): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${process.env.REACT_APP_CASES}/cases/getDashboardV2PieChart/${sprintIndex}`,
          {
            params: {
              limit: 10,
            },
          }
        )
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response)) {
            resolve(response);
          } else {
            reject(new Error(i18next.t('invalid_server_response')));
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(new Error(i18next.t('internal_server_error')));
        });
    });
  }

  async billableStatisticsExport({
    billingAccountIds,
    from,
    to,
    sprintId,
    organizationId,
  }: {
    billingAccountIds: string;
    from: string;
    to: string;
    sprintId: string;
    organizationId: string;
  }): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(`${process.env.REACT_APP_CASES}/cases/billableStatisticsExport`, {
          params: {
            billingAccountId: billingAccountIds,
            from,
            to,
            sprintId,
            organizationId,
          },
          responseType: 'blob',
        })
        .then((response) => {
          if (!isUndefined(response?.data)) {
            resolve(response?.data);
          } else {
            reject(new Error(i18next.t('invalid_server_response')));
          }
        })
        .catch((error) => {
          logger(error, 'error');
          reject(new Error(i18next.t('internal_server_error')));
        });
    });
  }
}

export const reportingApi = new ReportingApi();
